import React from "react";
import "./PrivacyPolicyPage.css";

const POLICY_SECTIONS = [
  {
    title: "O que coletamos sobre você",
    body: [
      "Perfis completos de usuários, leads, contatos e empresas: nome, e-mail, telefone, cargo, CNPJ/CPF, documentos anexados e histórico de comunicação gerado pelos fluxos de CRM.",
      "Informações de acesso e auditoria: IP, registros de login, devices, navegadores, localização aproximada e ações executadas (criar card, mover etapas, gerar orçamento, etc.).",
      "Tokens e chaves de integrações como Google Calendar, automações e webhooks. Guardamos somente dados de autenticação necessários para manter a integração ativa e renovamos os tokens quando expiram.",
    ],
  },
  {
    title: "Por que usamos seus dados",
    body: [
      "Autenticamos você, exibimos o menu apropriado (filtros, dashboards, campanhas, orçamentos) e personalizamos telas como CRM, Catálogo de Produtos e Tabelas Administrativas conforme permissões.",
      "Sincronizamos agendas com o Google Calendar, rastreamos eventos futuros e impedimos conflitos no TaskModal, além de alimentar relatórios de vendas, histórico de cartões e insights da equipe.",
      "Enviamos mensagens de alerta, e-mails de notificações, geramos PDFs de orçamentos e acionamos automações configuradas no painel de funil/atividades.",
      "Compartilhamos dados com provedores essenciais (ex.: Flowbite para UI, Axios para requisições, serviços de e-mail) apenas para executar essas tarefas; nunca vendemos ou trocamos listas comerciais.",
    ],
  },
  {
    title: "Bases legais e conservação",
    body: [
      "Tratamos dados para cumprir obrigações contratuais e legais (LGPD, obrigações fiscais, auditorias internas) e com base no legítimo interesse de manter o produto funcional e seguro.",
      "Mantemos informações enquanto a conta estiver ativa ou até o término da retenção exigida pelo compliance; dados de cobranças ficam por até 7 anos, enquanto logs e históricos de card ficam por 3 anos, salvo solicitações contrárias.",
    ],
  },
  {
    title: "Segurança técnica",
    body: [
      "Protegemos tudo com criptografia em trânsito (TLS) e em repouso (AES-256), além de controles de acesso baseados em permissão e time, auditoria contínua e revisão de tokens de integração.",
      "Ferramentas como o Analytics e as notificações usam dados anonimizados e pipelines monitorados; alertas disparam em caso de comportamentos suspeitos.",
    ],
  },
  {
    title: "Direitos dos titulares",
    body: [
      "Você pode acessar, corrigir, excluir ou portar seus dados via Perfil, abrir chamado ou falar com o time de suporte (suporte@empresa).",
      "Oferecemos cancelamento de marketing, limitação de tratamento e revogação de consentimentos; basta pedir e responderemos dentro dos prazos legais.",
    ],
  },
  {
    title: "Integrações, cookies e tokens",
    body: [
      "Cookies mantêm sua sessão, memorizam preferências e registram a experiência nas páginas de catálogo, funis e automações.",
      "Integrações como Google Calendar armazenam tokens (tokenType, access token, refresh token, expiresIn) dentro do nosso módulo de integrações para que você possa agir sem reingressar credenciais.",
    ],
  },
  {
    title: "Contato e governança",
    body: [
      "Suporte e relacionamento são feitos por e-mail, chat e tickets; registramos solicitações, mantém histórico e respondemos em até 3 dias úteis.",
      "Caso queira escalar uma solicitação, entre em contato com o DPO ou consulte o administrador do seu workspace; temos um canal dedicado a incidentes de segurança.",
    ],
  },
];

const PrivacyPolicyPage = () => (
  <div className="privacy-page light">
    <div className="privacy-content">
      <header className="privacy-hero">
        <span className="privacy-label">LEGAL</span>
        <h1>Política de Privacidade</h1>
        <p>
          Entenda como preservamos sua privacidade, protegemos seus dados e
          mantemos integrações com OAuth e calendários alinhadas com o seu
          workspace.
        </p>
      </header>

      <section className="privacy-sections">
        {POLICY_SECTIONS.map((section) => (
          <article key={section.title} className="privacy-section">
            <h2>{section.title}</h2>
            <div>
              {section.body.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </article>
        ))}
      </section>

      <footer className="privacy-footer">
        <p>
          Dúvidas ou solicitações de revisão, portabilidade ou exclusão podem ser
          feitas por e-mail ou pelo chat de suporte. Há um canal de resposta para
          incidentes de segurança.
        </p>
      </footer>
    </div>
  </div>
);
 
export default PrivacyPolicyPage;
